export default __webpack_public_path__ + "static/media/mcToad.c55ca2ab.png";